module.exports = __webpack_public_path__ + "img/success-application.bc70b1a3.png";